import React from "react";

/**
 * CompactUserCard - Horizontal compact card component for displaying users
 * Optimized for followers/following lists with better mobile layout
 *
 * @param {string} username - User's username
 * @param {string} image - User's profile picture URL
 * @param {boolean} online - Whether the user is online
 * @param {function} onSelect - Handler for card click
 */
export default function CompactUserCard({
  username,
  image,
  online,
  onSelect,
}) {
  return (
    <div
      onClick={onSelect}
      className="group flex items-center gap-3 p-2.5 md:p-3 bg-secondary border border-neutral-800 rounded-md cursor-pointer transition-all duration-150 hover:border-neutral-700"
    >
      {/* Avatar with online status */}
      <div className="relative flex-shrink-0">
        <img
          src={image}
          alt={username}
          className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover border-2 border-neutral-700"
        />

        {/* Online Status Indicator */}
        {online !== undefined && (
          <div
            className="absolute -bottom-0.5 -right-0.5 w-3.5 h-3.5 md:w-4 md:h-4 rounded-full border border-neutral-700"
            style={{ backgroundColor: online ? "#0dd15e" : "#AAA" }}
          />
        )}
      </div>

      {/* Username */}
      <div className="flex-1 min-w-0">
        <p className="text-sm md:text-base font-semibold text-text truncate group-hover:text-accent transition-colors">
          {username}
        </p>
      </div>
    </div>
  );
}
